import { PUBLIC_APP_ENV } from '$env/static/public';

export const semanticVersion = '0.3.24';

export const production = PUBLIC_APP_ENV === 'production';

export const charsPerToken = 4.5;
